import React from 'react';
import { motion } from 'framer-motion';
import { Stethoscope, Home, HeartPulse, Sparkles, Activity, Car } from 'lucide-react';
import { PageHeader } from '../components/PageHeader';
import { HowItWorks } from '../components/HowItWorks';
import { CTABanner } from '../components/CTABanner';
const detailedServices = [{
  icon: Stethoscope,
  title: 'Medical Care',
  description: 'Comprehensive medical support from certified professionals, tailored to your specific health needs and delivered with utmost compassion.',
  offerings: ['Medication management and administration', 'Wound care and dressing changes', 'Vital signs monitoring and reporting', 'Post-surgical recovery support']
}, {
  icon: Home,
  title: 'Home Care',
  description: 'Compassionate daily assistance allowing you or your loved ones to age comfortably in place while maintaining independence and dignity.',
  offerings: ['Assistance with daily living activities (ADLs)', 'Meal preparation and nutritional support', 'Light housekeeping and organization', 'Companionship and social engagement']
}, {
  icon: HeartPulse,
  title: 'Therapy & Rehabilitation',
  description: 'Personalized physical, occupational, and speech therapy programs designed to restore mobility, function, and overall independence.',
  offerings: ['In-home physical therapy sessions', 'Occupational therapy for daily tasks', 'Speech and swallowing therapy', 'Fall prevention and home safety assessments']
}, {
  icon: Sparkles,
  title: 'Wellness Programs',
  description: 'Holistic activities and programs designed to nurture mental, emotional, and social well-being for a balanced and fulfilling life.',
  offerings: ['Cognitive stimulation activities', 'Gentle exercise and yoga classes', 'Art and music therapy sessions', 'Support groups for patients and families']
}, {
  icon: Activity,
  title: 'Specialized Nursing',
  description: 'Expert care for complex medical conditions requiring specialized knowledge, continuous monitoring, and advanced clinical skills.',
  offerings: ['Diabetes management and education', 'Cardiac care and monitoring', 'Respiratory therapy and support', 'Palliative and end-of-life care']
}, {
  icon: Car,
  title: 'Transportation Services',
  description: 'Safe, reliable, and comfortable transportation for medical appointments, errands, and social outings, ensuring you stay connected.',
  offerings: ['Wheelchair-accessible vehicles', 'Door-to-door assistance', 'Accompaniment to medical appointments', 'Scheduled grocery and errand runs']
}];
export function ServicesPage() {
  return <div className="bg-nude-light min-h-screen" data-id="element-348">
      <PageHeader title="Our Services" subtitle="Comprehensive, compassionate care designed around your unique needs and lifestyle." data-id="element-349" />

      <section className="py-20" data-id="element-350">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-351">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-352">
            <h2 className="text-3xl md:text-4xl font-serif text-chocolate mb-6" data-id="element-353">
              A Holistic Approach to Your Well-being
            </h2>
            <p className="text-lg text-chocolate/80 leading-relaxed" data-id="element-354">
              At Crownehealth, we believe that true care goes beyond medical
              treatment. It's about understanding the person, respecting their
              dignity, and enhancing their quality of life. Our comprehensive
              suite of services is designed to provide seamless support at every
              stage of your healthcare journey.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-355">
            {detailedServices.map((service, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-white rounded-3xl p-8 shadow-soft hover:shadow-soft-lg transition-shadow border border-nude/30" data-id="element-356">
                <div className="w-16 h-16 rounded-2xl bg-nude flex items-center justify-center text-chocolate mb-6" data-id="element-357">
                  <service.icon size={32} strokeWidth={1.5} data-id="element-358" />
                </div>
                <h3 className="text-2xl font-serif font-bold text-chocolate mb-4" data-id="element-359">
                  {service.title}
                </h3>
                <p className="text-chocolate/80 leading-relaxed mb-6" data-id="element-360">
                  {service.description}
                </p>
                <ul className="space-y-3" data-id="element-361">
                  {service.offerings.map((offering, i) => <li key={i} className="flex items-start gap-3 text-chocolate/70" data-id="element-362">
                      <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2 shrink-0" data-id="element-363" />
                      <span data-id="element-364">{offering}</span>
                    </li>)}
                </ul>
              </motion.div>)}
          </div>
        </div>
      </section>

      <HowItWorks data-id="element-365" />
      <CTABanner data-id="element-366" />
    </div>;
}